import { render } from "./RestoreResourceModal.vue?vue&type=template&id=61f8a234"
import script from "./RestoreResourceModal.vue?vue&type=script&lang=js"
export * from "./RestoreResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"RestoreResourceModal.vue"]])

export default __exports__